"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FieldContext = /*#__PURE__*/_react.default.createContext({
  addAdditionalInputProp: function addAdditionalInputProp() {},
  addValidation: function addValidation() {},
  initialize: function initialize() {},
  isRequired: false,
  label: "",
  fieldName: "",
  removeValidation: function removeValidation() {},
  setIsRequired: function setIsRequired() {},
  setFieldName: function setFieldName() {},
  setShowDefaultLabel: function setShowDefaultLabel() {},
  setValidateOnChange: function setValidateOnChange() {},
  showDefaultLabel: true,
  terminate: function terminate() {},
  validate: function validate() {
    return [];
  }
});
var _default = FieldContext;
exports.default = _default;